import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Checkbox } from '@material-ui/core';
import TreezPopper from './TreezPopper';
import { makeStyles } from '@material-ui/core/styles';
import {
  BORDER_GREY,
  LIGHT_GREEN
} from "../../config/colors";
import './style.css';

const MultiSelectFilter = (props) => {

  const useStyles = makeStyles({
    root: {
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: BORDER_GREY
      },
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: props.color || LIGHT_GREEN
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: props.color || LIGHT_GREEN
      },
      '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        padding: '2px',
      },
    },
  });

  const classes = useStyles();


  const handleClick = (option) => {
    const {
      selectFilter,
      isFilterChecked,
      filterOnClose,
      filters,
      filterType,
    } = props;
  
    if (isFilterChecked(filterType, option)) {
      filterOnClose(filterType, option);
    } else {
      const existingFilters = (filters[filterType] || []);
      selectFilter(filterType, [...existingFilters, option]);
    }
  }
  const {
    isFilterChecked,
    filterType,
    options
  } = props;

  return (
    <Autocomplete
      PopperComponent={TreezPopper}
      multiple
      renderTags={() => null}
      id="multiple-limit-tags"
      options={options}
      getOptionLabel={(option) => option}
      disableCloseOnSelect
      renderInput={(params) => (
        <TextField 
          {...params}
          variant="outlined" 
          label="" 
          placeholder={`Select ${filterType}`}
          className={classes.root}
        />
      )}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox
            style={{ marginRight: 8, color: props.color || LIGHT_GREEN }}
            checked={isFilterChecked(filterType, option)}
            onChange={() => handleClick(option)}
          />
          {
            <div
              className='clickable'
              onClick={() => handleClick(option)}
            >
              {option}
            </div>
          }
        </React.Fragment>
      )}
    />
  );
};

export default MultiSelectFilter;



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/MultiSelectFilter.jsx